import { getJq } from '../www/core';
import { handleAjaxResponseOnFormFail } from 'common/error_handling';

const $ = getJq();
const jQuery = getJq();
import './ui_blocker.js';

if (!$ && !window.jQuery && !window.$) {
  throw new Error('jQuery is not loaded.');
}

let app = {

  setupAjaxForms: function() {
    $('body').on('ajax:error', handleAjaxResponseOnFormFail);
  },

  setupUIBlocker: function () {
    // UI blocking functionality removed - handled by other systems
  },

  setupTooltips: function() {
    // Tooltips and popovers are now handled by Stimulus controllers
  },

  setupObservers: function() {
    let $body = $('body');
    $body.on('change', '.observe-field', function() {
      let fieldName;
      if ($(this).data('observe-field-name')) {
        fieldName = $(this).data('observe-field-name');
      } else {
        fieldName = $(this).attr('id');
      }
      $.ajax({
        url: $(this).data('observe-url'),
        dataType: 'script',
        data: fieldName + '=' + $(this).val()
      });
    });
  },

  setupAsyncLoaders: function() {
    //Async loaders
    $('.async-load').each(function() {
      //Only bother if visible
      if (!$(this).hasClass('loaded')) {
        let href = $(this).data('href');
        if (typeof href !== 'undefined') {
          $(this).load(href, function() {
            $(this).addClass('loaded');
          });
        }
      }
    });
    $('.async-panel').on('show.bs.collapse', function() {
      //Only bother if visible
      if (!$(this).hasClass('loaded')) {
        let href = $(this).data('href');
        if (typeof href !== 'undefined') {
          $(this).load(href, function() {
            $(this).addClass('loaded');
          });
        }
      }
    });

  },

  setupCheckAll: function() {
    // Check all check box
    let $body = $('body');
    $body.on('click', 'input[type=checkbox].check_all', function() {
      if ($(this).prop('checked')) {
        // check all the checkboxes in the table
        $(this)
          .parents('table,.check_all_parent')
          .find('input[type=checkbox]')
          .prop('checked', 'checked')
          .trigger('change');
        $(this)
          .parents('.checkbox_container')
          .find('input[type=checkbox]')
          .prop('checked', 'checked')
          .trigger('change');
      } else {
        $(this)
          .parents('table,.check_all_parent')
          .find('input[type=checkbox]')
          .prop('checked', false)
          .trigger('change');
        $(this)
          .parents('.checkbox_container')
          .find('input[type=checkbox]')
          .prop('checked', false)
          .trigger('change');
      }
    });
  },
  formatPhoneNumber: (str) => {
    //Filter only numbers from the input
    let cleaned = ('' + str).replace(/\D/g, '');

    //Check if the input is of correct
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      //Remove the matched extension code
      //Change this to format for any country code.
      let intlCode = (match[1] ? '+1 ' : '')
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }

    return null;
  }
};

window.app = app;
export { app };
